import { type StatTone } from '~/components/StatCard'

// 달성 비율 → 의미색(StatCard/배지 공용): 충분 success · 보통 warning · 미흡 danger.
export function ratioTone(ratio: number | null): StatTone {
    if (ratio == null) return 'default'
    if (ratio >= 0.8) return 'success'
    if (ratio >= 0.5) return 'warning'
    return 'danger'
}

// 합격 가능성 등급 → 의미색(높음 success · 보통 warning · 낮음 danger).
export function likelihoodTone(value: string | null | undefined): StatTone {
    const k = value?.toLowerCase()
    if (k === 'high' || k === '높음') return 'success'
    if (k === 'medium' || k === '보통') return 'warning'
    if (k === 'low' || k === '낮음') return 'danger'
    return 'default'
}
